import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
const switchLabelCss = "s1jyj70b";
const SwitchLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchLabelCss, props.className)} />;
});
const styledSwitchCss = "s105cznz";
const StyledSwitch = forwardRef((props, ref) => <SwitchInput ref={ref} {...props} className={classNames(styledSwitchCss, props.className)} />);
const switchPrimaryLabelTextStyleCss = "sli6dkx";
const SwitchPrimaryLabelTextStyle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(switchPrimaryLabelTextStyleCss, props.className)} />;
});
const switchSubLabelTextCss = "s19qzaqo";
const SwitchSubLabelText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(switchSubLabelTextCss, props.className)} />;
});
const SwitchPrimaryLabelTextValue = ({
  isConfigured
}) => {
  if (isConfigured) {
    return I18n.t('publisher.organization_settings.user_provisioning.groups.switch_on');
  }
  return I18n.t('publisher.organization_settings.user_provisioning.groups.switch_off');
};
const SwitchPrimaryLabelText = ({
  isConfigured
}) => <SwitchPrimaryLabelTextStyle>
    <SwitchPrimaryLabelTextValue isConfigured={isConfigured} />
  </SwitchPrimaryLabelTextStyle>;
export const SwitchField = ({
  isConfigured,
  onChange
}) => <SwitchLabel>
    <StyledSwitch checked={isConfigured} onChange={onChange} />
    <div>
      <SwitchPrimaryLabelText isConfigured={isConfigured} />
      <SwitchSubLabelText>
        {HtmlParser(I18n.t('publisher.organization_settings.user_provisioning.groups.description'))}
      </SwitchSubLabelText>
    </div>
  </SwitchLabel>;

require("./switch_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./switch_field.js");